<template>
  <div class="btn-group">
    <el-tooltip v-if="canView" content="Show" effect="light" placement="top-start" :open-delay="300">
      <button class="btn btn-secondary btn-sm btn-width-fixed" @click="view">
        <i class="fas fa-info"></i>
      </button>
    </el-tooltip>
    <el-tooltip v-if="canEdit" content="Edit" effect="light" placement="top-start" :open-delay="300">
      <button class="btn btn-secondary btn-sm" @click="edit">
        <i class="fas fa-edit"></i>
      </button>
    </el-tooltip>
    <el-tooltip v-if="canClone" content="Clone" effect="light" placement="top-start" :open-delay="300">
      <button class="btn btn-secondary btn-sm" @click="clone">
        <i class="fas fa-clone"></i>
      </button>
    </el-tooltip>
    <el-tooltip v-if="canCloneWithContacts" content="Clone & Create ContactList" effect="light" placement="top-start" :open-delay="300">
      <button class="btn btn-secondary btn-sm" @click="cloneWithContacts">
        <i class="far fa-clone"></i>
      </button>
    </el-tooltip>
    <el-tooltip v-if="canDelete" content="Delete" effect="light" placement="top-start" :open-delay="300">
      <button class="btn btn-danger btn-sm" @click="confirmDeleting">
        <i class="fas fa-trash-alt"></i>
      </button>
    </el-tooltip>
  </div>
</template>

<script>

export default {
  props: [
    'row'
  ],

  computed: {
    /**
     * @return {boolean}
     */
    canEdit() {
      return this.row.canEdit;
    },

    /**
     * @return {boolean}
     */
    canDelete() {
      return this.row.canDelete;
    },

    /**
     * @return {boolean}
     */
    canClone() {
      return this.row.canClone;
    },

    /**
     * @return {boolean}
     */
    canView() {
      return this.row.canView;
    },

    /**
     * @return {boolean}
     */
    canCloneWithContacts() {
      return this.row.canCloneWithContacts;
    },

    /**
     * @return {string}
     */
    editUrl() {
      return this.row.editUrl;
    },

    /**
     * @return {string}
     */
    deleteUrl() {
      return this.row.deleteUrl;
    },

    /**
     * @return {string}
     */
    cloneUrl() {
      return this.row.cloneUrl;
    },

    /**
     * @return {string}
     */
    cloneWithContactsUrl() {
      return this.row.cloneWithContactsUrl;
    },

    /**
     * @return {string}
     */
    viewUrl() {
      return this.row.viewUrl;
    },
  },

  methods: {
    /**
     * @event edit
     */
    edit() {
      this.$emit('edit', {row: this.row, url: this.editUrl});
    },

    /**
     * @event clone
     */
    clone() {
      this.$emit('clone', {row: this.row, url: this.cloneUrl});
    },

    /**
     * @event clone
     */
    cloneWithContacts() {
      this.$emit('clone-with-contacts', {row: this.row, url: this.cloneWithContactsUrl});
    },

    /**
     * @event view
     */
    view() {
      this.$emit('view', {row: this.row, url: this.viewUrl});
    },

    /**
     * @event delete
     */
    confirmDeleting() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => {
          });
    },
  },
}
</script>

